import {
  Box,
  TableContainer,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';
import {
  GetSchedulesDocument,
  CompanyResourceResourceTypeEnum,
  ResourceScheduleStatusEnum,
} from '@/graphql/generated/graphql';
import { useQuery } from '@apollo/client/react';
import { ReportContext } from '@/Contexts/ReportContext';
import { useContext } from 'react';
import { map } from 'lodash';
import dayjs from 'dayjs';
import { objectLength } from '@/utils/helperFunctions';
import CurrentUserContext from '@/Contexts/CurrentUser';

const PeopleRegister = () => {
  const { dateTimePreference } = useContext(CurrentUserContext);
  const { selectedReport, selectedProject } = useContext(ReportContext);
  const { data } = useQuery(GetSchedulesDocument, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !selectedReport,
    variables: {
      date: selectedReport?.reportDate as string,
      projectId: selectedProject?.id as string,
      resourceType: CompanyResourceResourceTypeEnum.Human,
    },
  });

  const getStatusIcon = (value: ResourceScheduleStatusEnum) => {
    switch (value) {
      case ResourceScheduleStatusEnum.Scheduled:
        return <CheckCircleOutlineIcon color="success" fontSize="small" />;
      case ResourceScheduleStatusEnum.Dropped:
        return <CancelIcon color="error" fontSize="small" />;
      case ResourceScheduleStatusEnum.Missed:
        return <ErrorIcon color="error" fontSize="small" />;
      case ResourceScheduleStatusEnum.Completed:
        return <CheckCircleIcon color="success" fontSize="small" />;
      default:
        return null;
    }
  };

  return (
    <TableContainer component={Paper} elevation={1}>
      <Box sx={{ p: 2, bgcolor: '#e3f2fd' }}>
        <Typography variant="h6" sx={{ color: '#0d47a1', fontWeight: 600 }}>
          People Register
        </Typography>
      </Box>

      {objectLength(data?.getSchedules) === 0 ? (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">No schedules recorded for the date.</Typography>
        </Box>
      ) : (
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Check In</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Check Out</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {map(data?.getSchedules, (row, index) => (
              <TableRow key={index} hover>
                <TableCell sx={{ fontWeight: 500 }}>{row?.companyResource?.name}</TableCell>
                <TableCell>{dayjs(row?.startTime).format(dateTimePreference.time)}</TableCell>
                <TableCell>{dayjs(row?.endTime).format(dateTimePreference.time)}</TableCell>
                <TableCell>{getStatusIcon(row?.status)}</TableCell>
                <TableCell>{row?.address.title}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default PeopleRegister;
